import React from 'react'
import s from './styles/RecommendationAttachment.module.scss'

export function PreviewMetric({ label, value, Icon }) {
	if (!value) return null
	return (
		<div className={s.metric}>
			<span className={s.metricLabel}>{label}</span>
			<span className={s.metricValue}>
				{Icon ? <Icon className={s.metricIcon} /> : null}
				{value}
			</span>
		</div>
	)
}
